/**
 * The app's primary action button.
 *
 * Shape, motion and elevation come from `.ce-btn` + `.ce-btn-accent`
 * (neumorph2026.css §3): a pill on the market's accent gradient, carrying a
 * *coloured* shadow rather than a grey one. That coloured shadow is what makes
 * the primary read as the primary without needing extra size.
 *
 * The fill reads `--cat-accent` / `--cat-accent-lift`, so on a trading page it
 * takes the market's category colour (stocks green, commodities gold …) and
 * lifts in dark mode. Off a trading page the tokens resolve to brand purple.
 *
 * A real `<button>` rather than the div it used to be: it needs to be
 * focusable, Enter/Space-activatable and announced as a button.
 */
export const PurpleButton = ({ text, onClick = () => {}, disabled, className = "" }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`ce-btn ce-btn-accent ${className}`.trim()}
    >
      {text}
    </button>
  );
};
